import api from "./apiV1";

export const getAreaInformationTypes = () => {
  return api.get("areas-information-types");
};
